import { SkeletonFieldProps, SKELETON_INPUT_HEIGHT } from '../Skeleton.types';
import { SkeletonBox } from './SkeletonBox';

export const SkeletonField = ({ type = 'text', width = '100%', sx }: SkeletonFieldProps) => {
    if (type === 'textarea') {
        return <SkeletonBox width={width} height={SKELETON_INPUT_HEIGHT * 3} sx={sx} />;
    }

    return <SkeletonBox width={width} height={SKELETON_INPUT_HEIGHT} sx={sx} />;
};
